import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import { ZalamoObject } from '@ui/orders/graphql';

interface SimpleMenuItem {
  label: string;
  canAdd: boolean;
  [key: string]: any;
}

@Component({
    selector: 'lib-tablo-layers-editor',
    templateUrl: './tablo-new-layers-editor.component.html',
    styleUrls: ['./tablo-new-layers-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabloNewLayersEditorComponent implements OnInit {
  @Input() membersMenu$!: Observable<SimpleMenuItem[]>;
  @Input() namesMenu$!: Observable<
    { name: string; type: ZalamoObject; canAdd: boolean }[]
  >;
  @Input() leadingChild$!: Observable<{ canAdd: boolean }>;
  @Input() leadingChildPhotoOnly$!: Observable<{ canAdd: boolean }>;
  @Input() leadingChildNameOnly$!: Observable<{ canAdd: boolean }>;
  @Input() organizationLogo$!: Observable<{ canAdd: boolean }>;
  @Input() photographerLogo$!: Observable<{ canAdd: boolean }>;
  @Input() isSinglePageTablo = false;

  @Output() addMembersGroup = new EventEmitter<any>();
  @Output() addLeadingChild = new EventEmitter<{
    isNameOnly?: boolean;
    isPhotoOnly?: boolean;
  }>();
  @Output() addText = new EventEmitter<any>();
  @Output() addLogo = new EventEmitter<void>();
  @Output() addPhotographerLogo = new EventEmitter<void>();
  @Output() addStaticText = new EventEmitter<void>();
  @Output() addGraphic = new EventEmitter<Event>();
  @Output() addSchoolPhoto = new EventEmitter<void>();
  @Output() addChildStaticPhoto = new EventEmitter<void>();
  @Output() addQr = new EventEmitter<void>();

  trackTextName(index, item) {
    return item.type;
  }

  ngOnInit(): void {}
}
